import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const ConditionalWrap = /* @__PURE__ */ __name(({
  children,
  condition,
  wrap
}) => /* @__PURE__ */ React.createElement(React.Fragment, null, condition ? wrap(children) : children), "ConditionalWrap");

export { ConditionalWrap };
//# sourceMappingURL=conditional-wrap.js.map
